import { handleSignOut } from "../../common/handleSignOut";
import styles from "./AuthenticationError.module.scss";
import { Button } from "@material-ui/core";
import { ReactComponent as ErrorHand } from "../../../images/error-hand.svg";
import { ReactComponent as SignoutIcon } from "../../../images/icon-signout.svg";

export interface UserExistsError {
  onLogout: () => void;
}

export const CommonAuthenticationError = () => {
  const logOut = () => {
    handleSignOut({ reason: "Authentication error", url: window.location.href })
  };
  return (
    <div className={styles.background}>
      <div className={styles.inner}>
        <div className={styles.content}>
          <div>
            <div className={styles.header}>
              Whoops... we’ve run into a problem
            </div>
            <div className={styles.body}>
              <ErrorHand />
              <div className={styles.message}>
                It looks like something went wrong. <br></br>
                Please try again or <a className={styles.link} href="mailto: Residential.Helpdesk@health.telstra.com">contact the support team</a>.
              </div>
              <Button onClick={logOut} className={styles.secondaryButton} style={{
                width: "207px"
              }} startIcon={<SignoutIcon title="" />}>
                Sign out of MedPoint</Button>
            </div>
            <div className={styles.footer}>
              Illustrations by <a className={styles.link} href="https://www.freepik.com/" target="_blank">Freepik</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
